import ApplicationBar from './ApplicationBar'
import ApplicationBarLegacy from './legacy/ApplicationBarLegacy'
import PageDescription from './PageDescription'

export default ApplicationBar

export { ApplicationBarLegacy, PageDescription }
